import { createElement, forwardRef } from 'react';
import { circle } from '../patterns/circle.mjs';
import { splitProps } from '../helpers.mjs';
import { styled } from './factory.mjs';

export const Circle = /* @__PURE__ */ forwardRef(function Circle(props, ref) {
  const [patternProps, restProps] = splitProps(props, circle.propKeys)
  const styleProps = circle.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})